import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRobotoCondensed, theme } from "shared/lib/styles";

import { ContentItemHomeStoryPackageLead } from "scmp-app/components/content/content-item-render/variants/home-story-package-lead";
import { ContentItemHomeStoryPackageTail } from "scmp-app/components/content/content-item-render/variants/home-story-package-tail";
import { EntityLink } from "scmp-app/components/entity-link";
import { HomeFollowButton } from "scmp-app/components/home/follow-button";

export const StyledContentItemHomeStoryPackageLead = styled(ContentItemHomeStoryPackageLead)``;
export const StyledContentItemHomeStoryPackageTail = styled(ContentItemHomeStoryPackageTail)``;

export const Container = styled.div`
  display: grid;
  grid:
    "topic-name-follow" min-content
    "subsection" min-content
    "leading-article" min-content
    / 100%;

  ${theme.breakpoints.up("tablet")} {
    grid:
      "topic-name-follow subsection" min-content
      "leading-article leading-article" min-content
      / 1fr max-content;
  }
`;

export const TopicBadge = styled.div`
  grid-area: topic-name-follow;

  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  block-size: fit-content;
  margin-block-end: 20px;

  text-transform: uppercase;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 24px;
  }
`;

export const TopicNameEntityLink = styled(EntityLink)``;

export const TopicNameBaseLink = styled(BaseLink)``;

export const TopicName = styled.div`
  color: rgba(0, 0, 0, 0.5);
  font-weight: 400;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
  line-height: 24px;
  white-space: pre-line;
`;

export const StyledTopicFollowButton = styled(HomeFollowButton)`
  flex-shrink: 0;

  margin-inline-start: 12px;
`;

export const Articles = styled.div`
  grid-area: leading-article;
`;
